import instance, { ApiResponse, isAxiosErrorHandled } from "api";
import { Modal } from "components/modal/Modal";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDropzone } from "react-dropzone";
import { AxiosRequestConfig } from "axios";
import { ERROR_CODES, getErrorMessage } from "errors";
import { endpoints } from "config";
import UploadIcon from "assets/Icon_Upload.png";
import { Form, Formik, FormikHelpers } from "formik";
import FormTextField from "components/form/FormTextField";
import { ModalTypes, closeModal, selectModalState } from "reducers/globalModal";
import { useResetableDropzone } from "components/helpers/useResetableDropzoneBusinessForm";
import Button from "components/ui/Button";

const roundToPrecision = (value: number, precision: number) =>
  parseFloat(value.toFixed(precision));

type DepositAddressInfo = {
  address: string;
  qrCode: string;
};
type FormValues = {
  note: string;
};
const initialValues: FormValues = {
  note: "",
};
export const UploadDocumentModalBusinessForm = () => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const modalState = useSelector(selectModalState);
  let fieldName = "";
  let values = null;
  if (modalState?.data?.fieldName && modalState?.data?.values) {
    //@ts-ignore
    fieldName = modalState.data.fieldName;
    //@ts-ignore
    values = modalState.data.values;
  }
  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    resetFiles,
  } = useResetableDropzone(
    {
      multiple: false,
      accept: "application/pdf",
      onDropRejected: (rejections, event) => {
        if (
          rejections.some((reject: any) =>
            reject.errors.some(
              (error: any) => error.code === "file-invalid-type"
            )
          )
        ) {
          setErrorMessage("File type must be .pdf");
        } else
          setErrorMessage("File rejected - please upload a valid .pdf file");
      },
    },
    fieldName,
    values,
    setErrorMessage
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => setErrorMessage(""), [acceptedFiles]); //reset error message when files change

  // if (modalState.modalType !== ModalTypes.UPLOAD_BUSINESS_DOCUMENT) return null;

  const handleSubmit = (
    values: FormValues,
    helpers: FormikHelpers<FormValues>
  ) => {
    if (!acceptedFiles || acceptedFiles.length < 1)
      return setErrorMessage("Please upload a file");
    setIsSubmitting(true);
    setErrorMessage("");
    const formData = new FormData();
    //@ts-ignore
    formData.append("documentId", modalState.data.documentId.toString());
    formData.append("file", acceptedFiles[0]);
    formData.append("note", values.note);

    const config: AxiosRequestConfig = {
      headers: { "content-type": "multipart/form-data" },
    };
    instance
      .post(endpoints.verification.uploadDocument, formData, config)
      .then(res => {
        if (res.status === 200) {
          if (res.data.status === "1") {
            modalState.data?.reloadTable();
            modalState.data?.helpers?.setValue(acceptedFiles[0].name);
            dispatch(closeModal());
          }
        }
      })
      .catch(err => {
        let translatedErrorMessage = getErrorMessage("Generic");
        // Generic error

        if (isAxiosErrorHandled(err) && err.response.data.errors) {
          err.response.data.errors.forEach(error => {
            if (error.messageCode in ERROR_CODES)
              translatedErrorMessage = getErrorMessage(error.messageCode);
          });
        }
        if (isAxiosErrorHandled(err) && err.response.status === 413) {
          translatedErrorMessage = "File too large";
        }

        setErrorMessage(translatedErrorMessage);
        setIsSubmitting(false);
      });
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      <Form>
        <Modal
          className="DocumentUploadModal"
          title={`Upload ${modalState?.data?.documentName}`}
          closeModal={() => dispatch(closeModal())}
          open={true}
          customFooterButtons={
            <div className="ModalNavigation">
              <Button
                color="white"
                type="button"
                onClick={() => {
                  dispatch(closeModal());
                }}
              >
                Cancel
              </Button>
              <Button type="submit" disabled={isSubmitting}>
                Upload
              </Button>
            </div>
          }
        >
          <div className="UploadDocumentModal">
            {/*@ts-ignore*/}
            <p>Please upload your {modalState?.data?.documentName} below</p>
            <div {...getRootProps({ className: "Dropzone" })}>
              <input {...getInputProps()} />
              {acceptedFiles[0] ? (
                <span>
                  {acceptedFiles[0].name} -{" "}
                  {roundToPrecision(acceptedFiles[0].size / 1000, 2)} kB
                </span>
              ) : (
                <>
                  <img src={UploadIcon} alt="upload" />
                  <h5>PDF file</h5>
                  <span>Click or drag to upload</span>
                </>
              )}
            </div>
            <div className="DropzoneFooter">
              <span>Accepts - .pdf</span>
              {acceptedFiles.length > 0 && (
                <Button color="white" className="ResetBtn" onClick={resetFiles}>
                  Reset
                </Button>
              )}
            </div>
            <FormTextField
              field={"note"}
              label={"Notes"}
              type={"textarea"}
              required={false}
              inputProps={{ rows: 3, style: { resize: "vertical" } }}
            ></FormTextField>
            {errorMessage && (
              <p className="ErrorText NoMargin">{errorMessage}</p>
            )}
          </div>
        </Modal>
      </Form>
    </Formik>
  );
};
